<template>
  <z-form-group v-if="formatted_value.length" class="row">
    <z-form-input class="col-8 offset-4">
      <player-row v-for="file in formatted_value" :key="file.file_sln" :file="file">
        <table-control slot="controls" type="trash" @click="remove(file.file_sln)" />
      </player-row>
    </z-form-input>
  </z-form-group>
</template>

<script>
  import PlayerRow from '@autoinformer/components/media/_fragments/file-player-row';
  import { MediaService } from '@autoinformer/services/MediaService';

  export default {
    components: { PlayerRow },
    props: {
      value: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        files: []
      };
    },

    computed: {
      formatted_value: function () {
        return this.value.map((file) => this.get_file(file)).filter((file) => file);
      }
    },
    watch: {
      files() {
        this.$emit(
          'input',
          this.value
            .map((file) => this.get_file(file))
            .filter((file) => file)
            .map((i) => i.file_sln)
        );
      }
    },

    created() {
      const campaign_id = this.$route.params.id;
      MediaService.getSelect(campaign_id).then((res) => (this.files = res));
    },

    methods: {
      get_file: function (sln_file_search) {
        return this.files.find(({ file_sln }) => file_sln === sln_file_search);
      },
      remove: function (search) {
        const new_value = this.value.filter((file) => file !== search);
        this.$emit('input', new_value);
      }
    }
  };
</script>
